var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('page-breadcrumb',{staticClass:"mb-1",attrs:{"title":"Feedback"}}),_c('data-table-ssr',{ref:"feedback_list",attrs:{"id":"feedback_list","get-list-fn":_vm.getList,"columns":_vm.feedback_columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }